export default "__VITE_ASSET__763d91f6__"